import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import { Button } from 'react-bootstrap';

const dataJson = [
    {
        type: 1,
        heading: "Thank you for letting us know.",
        text: 'Your cancellation has been processed successfully. If you have any further questions or concerns, please feel free to reach out.',
        icon: <FontAwesomeIcon type={'solid'} icon={'circle-check'} iconClass={'text-success'} />
    },
    {
        type: 2,
        heading: "We're sorry to see you go.",
        text: 'Your cancellation has been processed successfully. If you have any further questions or concerns, please feel free to reach out.',
        icon: <FontAwesomeIcon type={'solid'} icon={'face-frown-slight'} iconClass={''} style={{color:"#212121"}} />
    },
    {
        type: 3,
        heading: "Your effective price will be ",
        text: 'Great! Your discount is now active. You will be charged 10% less on your next billing date.',
        icon: <FontAwesomeIcon type={'solid'} icon={'badge-percent'} iconClass={'text-success'} />
    },
]
const ContinueToCancel = ({ pageStatus, acceptOfferData, handleParentStatus }) => {
    const navigate = useNavigate()
    const [pageData, setPageData] = useState();

    const planDetails = () =>{
        handleParentStatus(false);
        navigate(`/walls/home`);
    }

    useEffect(() => {
        const res = dataJson.filter((value) => value.type == pageStatus)
        setPageData(res.length > 0 ? res[0] : res)
    }, [pageStatus]);

    return (
        <>
            {pageData && Object.keys(pageData).length > 0 ?
                <div className='small_container'>
                    <div className="p-md-10 p-5 bg-gray rounded">
                        <div className="text-center">
                            <p className="my-8">{pageData.icon} </p>
                            <h3 className='mb-5'>{pageData.heading}
                                {(pageStatus == 3 && Object.keys(acceptOfferData).length > 0 )&& <><del className='text-secondary'>{acceptOfferData.currency == 'inr' ? '₹' : '$'}{acceptOfferData.beforePercentage}</del> <span className='text-danger'>{acceptOfferData.currency == 'inr' ? '₹' : '$'}{acceptOfferData.afterPercentage}/{acceptOfferData.interval}</span></>}
                            </h3>
                            <p className="mb-8">{pageData.text}</p>

                            <Button variant='primary' className="px-8" onClick={() => planDetails()}>Go To Home</Button>

                        </div>
                    </div>
                </div> : null}</>
    )
}

export default ContinueToCancel